export const localisation = {
  data: {},

  set(name, value) {
    this.data[name] = JSON.parse(value)
  },

  get(name) {
    return this.data[name]
  },
}